// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"43":"cd19898b","166":"cd62aeaa","194":"29ea017d","338":"7a216be9","741":"1d3e51b0","950":"82ea04f2"}[chunkId] + ".chunk.js";
};